import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideServiceWorker } from '@angular/service-worker';

import { routes } from './app.routes';
import { authInterceptor, cacheInterceptor, errorInterceptor } from './core/interceptors';
import { provideAuthFeature } from './features/auth/auth.module';
import { provideServiceRequestFeature } from './features/service-request/service-request.module';
import { appFeature } from './core/store';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, cacheInterceptor])),
    provideStore({
      [appFeature.name]: appFeature.reducer,
    }),
    provideServiceRequestFeature(),
    provideAuthFeature(),
    provideServiceWorker('ngsw-worker.js', {
      // Drive from environment — not isDevMode(). ng serve is always "dev mode",
      // which previously forced SwUpdate.isEnabled === false.
      enabled: environment.serviceWorker,
      // Admin UI keeps sockets/timers alive, so "whenStable" can delay registration.
      registrationStrategy: environment.serviceWorker
        ? 'registerImmediately'
        : 'registerWhenStable:30000',
    }),
  ],
};
